(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.SurveyFieldsDialogController = (function(superClass) {
    extend(SurveyFieldsDialogController, superClass);

    function SurveyFieldsDialogController(scope, transitions, modalInstance, repo, survey_result) {
      var num_plans, sr;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.repo = repo;
      this.loadSurveyFields = bind(this.loadSurveyFields, this);
      SurveyFieldsDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      sr = survey_result;
      num_plans = Object.keys(sr.planned_fields).length;
      this.scope.title = sr.pp_name + " (" + num_plans + "/" + sr.num_fields + ") " + sr.date;
      this.scope.placeholder = 'Loading field list...';
      this.scope.fields = [];
      this.loadSurveyFields(survey_result);
    }

    SurveyFieldsDialogController.prototype.loadSurveyFields = function(survey_result) {
      return this.repo.getSurveyFields(survey_result).then((function(_this) {
        return function(result) {
          var ref, ref1, ref2, ref3;
          if (((ref = result.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) !== 'success') {
            if (((ref2 = result.data) != null ? ref2.status : void 0) != null) {
              _this.scope.setAlert((ref3 = result.data) != null ? ref3.status : void 0);
            } else {
              _this.scope.setAlert({
                type: 'error',
                msg: 'Failed to load field list for this survey result'
              });
            }
            return;
          }
          _this.scope.fields = result.data.data.fields;
          if (_this.scope.fields.length === 0) {
            return _this.scope.placeholder = 'No fields found';
          }
        };
      })(this), (function(_this) {
        return function() {
          return _this.scope.setAlert({
            type: 'error',
            msg: 'Failed to load field list for this survey result'
          });
        };
      })(this));
    };

    return SurveyFieldsDialogController;

  })(DialogController);

}).call(this);
